var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { IconButton } from '../../icon-button';
import { styled } from '../../styled';
var appBarIconButtonName = 'QuantumAppBarIconButton';
export var Root = styled(IconButton, { name: appBarIconButtonName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var _b = theme.mixins.appBarAction(), focus = _b.focus, hover = _b.hover, activeStyle = _b.active, root = _b.root;
    return __assign(__assign(__assign(__assign({}, root), { height: theme.typography.pxToRem(36), width: theme.typography.pxToRem(36), paddingTop: 0, paddingBottom: 0, '&:focus,&.Mui-focus': focus, '&:hover,&.Mui-hover': hover, '&:active,&.Mui-active': activeStyle, '& > svg:first-child': {
            flexShrink: 0,
            width: 'auto',
            height: 'auto',
        } }), (ownerState.active && activeStyle)), (ownerState.circular && { borderRadius: '50%' }));
});
export var AppBarIconButton = React.forwardRef(function (props, ref) {
    var color = props.color, className = props.className, active = props.active, _a = props.variant, variant = _a === void 0 ? 'link' : _a, circular = props.circular, _b = props.IconButtonProps, IconButtonProps = _b === void 0 ? {} : _b, children = props.children, rootProps = __rest(props, ["color", "className", "active", "variant", "circular", "IconButtonProps", "children"]);
    return (React.createElement(Root, __assign({}, { ref: ref }, { className: className, ownerState: { active: active, circular: circular } }, rootProps, { variant: variant, color: "inherit" }, IconButtonProps), children));
});
